/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Adressen für den internen Versand */
export interface AddressDto {
  /** @example "b" */
  addition?: string;
  /**
   * @minLength 1
   * @example "Hamburg"
   */
  city: string;
  /**
   * Country code in ISO-3166-1 ALPHA-2 format
   * @minLength 1
   * @example "DE"
   */
  country: string;
  /** @example "1" */
  houseNumber?: string;
  /**
   * @minLength 1
   * @example "22089"
   */
  postCode: string;
  /**
   * @minLength 1
   * @example "Wartenau"
   */
  street: string;
}

export interface AuditInfoDto {
  /**
   * @minLength 1
   * @example "system"
   */
  createdBy: string;
  /** @format date-time */
  createdDate: string;
  /**
   * @minLength 1
   * @example "system"
   */
  lastModifiedBy: string;
  /** @format date-time */
  lastModifiedDate: string;
  /**
   * @format int64
   * @example 1
   */
  version: number;
}

export interface CustomerProjectionDto {
  /** @format uuid */
  customerId?: string;
  customerNumber?: string;
  displayName?: string;
  name?: string;
}

/** Document Type */
export enum DocumentTypeDto {
  COR_I = "COR_I",
  COR_II = "COR_II",
  COC = "COC",
  ABE = "ABE",
  CERT = "CERT",
  CONTRACT = "CONTRACT",
  SALARY_STATEMENT = "SALARY_STATEMENT",
  ID_CARD = "ID_CARD",
  OTHER = "OTHER",
  CAR_KEY = "CAR_KEY",
  LICENSE_PLATE_FRONT = "LICENSE_PLATE_FRONT",
  LICENSE_PLATE_REAR = "LICENSE_PLATE_REAR",
  WARRANTY = "WARRANTY",
  RADIO_CODE = "RADIO_CODE",
}

export interface FieldValidationDto {
  code?: string;
  field?: string;
  message?: string;
}

export interface PlacementProcessBatchCompleteDto {
  cabinet?: string;
  /** @minLength 1 */
  ids: string[];
  /** @format uuid */
  printerId: string;
}

export interface PlacementProcessCompletableDto {
  isCompletable: boolean;
}

export interface PlacementProcessCompleteDto {
  cabinet?: string;
  /** @format uuid */
  printerId: string;
}

export interface PlacementProcessDetailDto {
  audit: AuditInfoDto;
  /** PlacementProcess Daten */
  data: PlacementProcessDto;
}

/** Liste der Dokumente eines Einlagerungsprozess */
export interface PlacementProcessDocumentDto {
  /** Document Id */
  documentId: string;
  /** Document Type */
  documentType: DocumentTypeDto;
  /**
   * Document Position
   * @format int64
   */
  position: number;
  /** Indicates if the document is ready to store */
  status: PlacementProcessDocumentStatusDto;
  /** Storage location */
  storageLocation?: string;
  /**
   * Id of the VehicleDataAcquisition
   * @format uuid
   */
  vdaId: string;
  /** Related VIN projected from VDA */
  vin: string;
}

export enum PlacementProcessDocumentExistenceFilterDto {
  EXISTS = "EXISTS",
  NOT_EXISTS = "NOT_EXISTS",
}

/** Indicates if the document is ready to store */
export enum PlacementProcessDocumentStatusDto {
  ANNOUNCED = "ANNOUNCED",
  ANNOUNCEMENT_REVOKED = "ANNOUNCEMENT_REVOKED",
  PROCESSING = "PROCESSING",
  READY = "READY",
  CLARIFICATION = "CLARIFICATION",
}

/** PlacementProcess Daten */
export interface PlacementProcessDto {
  /** @minLength 1 */
  correlationId: string;
  /**
   * CMS Kunden id
   * @format uuid
   */
  customerId: string;
  /** Liste der Dokumente eines Einlagerungsprozess */
  documents?: PlacementProcessDocumentDto[];
  /** Beauftragendes System */
  origin: PlacementProcessOriginDto;
  /**
   * PMS Drucker Id
   * @format uuid
   */
  printerId?: string;
  /** Status des Einlagerungsprozess */
  status?: PlacementProcessStatusDto;
  /** Username */
  username: string;
}

export interface PlacementProcessListDto {
  /** Liste von Einlagerungsprozessen */
  items: PlacementProcessListItemDto[];
  /**
   * Anzahl Seiten für Anzeige von Einlagerungsprozessen
   * @format int32
   */
  totalPages: number;
}

/** Liste von Einlagerungsprozessen */
export interface PlacementProcessListItemDto {
  /** Einlagerungsprozesskennung */
  correlationId: string;
  /** Kunde */
  customer: string;
  /** @format uuid */
  customerId: string;
  /**
   * Einlagerungsprozess Id
   * @format uuid
   */
  id: string;
  /** Beauftragendes System */
  origin: PlacementProcessOriginDto;
  /** Status des Einlagerungsprozess */
  status: PlacementProcessStatusDto;
  /** Benutzer */
  user: string;
}

/** Beauftragendes System */
export enum PlacementProcessOriginDto {
  SEA = "SEA",
  VDA = "VDA",
  STS = "STS",
  SLS = "SLS",
}

/** Status des Einlagerungsprozess */
export enum PlacementProcessStatusDto {
  ACTIVE = "ACTIVE",
  CLOSING = "CLOSING",
  CLOSING_BATCH = "CLOSING_BATCH",
  CLOSED = "CLOSED",
}

export interface PrinterProjectionDto {
  displayName: string;
  name: string;
  /** @format uuid */
  printerId: string;
}

export interface ResourceCreatedDto {
  /** @format uuid */
  id?: string;
}

export interface UserProjectionDto {
  active?: boolean;
  firstname?: string;
  keycloakId?: string;
  lastname?: string;
  /** @format uuid */
  userId?: string;
  username?: string;
}

export interface ValidationDto {
  fields?: FieldValidationDto[];
}

/** Lagerstandortdaten */
export interface WarehouseDataDto {
  /** Adressen für den internen Versand */
  internalAddresses?: AddressDto[];
  /**
   * Lagername
   * @minLength 1
   */
  name: string;
  /**
   * Lagerkennziffer
   * @minLength 1
   */
  warehouseNumber: string;
}

export interface WarehouseDetailDto {
  audit?: AuditInfoDto;
  /** Lagerstandortdaten */
  data: WarehouseDataDto;
}

export interface WarehouseListDto {
  /** Liste von Lagerstandorten */
  items: WarehouseListItemDto[];
}

/** Liste von Lagerstandorten */
export interface WarehouseListItemDto {
  /**
   * Lager Id
   * @format uuid
   */
  id: string;
  /** Lagername */
  name: string;
  /** Lagerkennziffer */
  warehouseNumber: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Storage Location Service by Kroschke
 * @version 0.1
 * @baseUrl /
 */
export class Sls<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Customer Projection
     * @name FindCustomers
     * @summary Find first 50 active customers
     * @request GET:/api/v1/projection/customer
     * @secure
     */
    findCustomers: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerProjectionDto[], any>({
        path: `/api/v1/projection/customer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer Projection
     * @name GetCustomerCabinets
     * @summary Get cabinets for a customer
     * @request GET:/api/v1/projection/customer/{id}/cabinets
     * @secure
     */
    getCustomerCabinets: (id: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/api/v1/projection/customer/${id}/cabinets`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Printer Projection
     * @name FindZebraPrinters
     * @summary Find first 50 ZEBRA printers
     * @request GET:/api/v1/projection/printer/zebra
     * @secure
     */
    findZebraPrinters: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PrinterProjectionDto[], any>({
        path: `/api/v1/projection/printer/zebra`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Projection
     * @name FindUsers
     * @summary Find first 50 active users
     * @request GET:/api/v1/projection/user
     * @secure
     */
    findUsers: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserProjectionDto[], any>({
        path: `/api/v1/projection/user`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Projection
     * @name GetUserByUsername
     * @summary Get user by username
     * @request GET:/api/v1/projection/user/{username}
     * @secure
     */
    getUserByUsername: (username: string, params: RequestParams = {}) =>
      this.request<UserProjectionDto, any>({
        path: `/api/v1/projection/user/${username}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags storage-logistic-controller
     * @name ListPlacementProcesses
     * @summary Returns a list of placement processes
     * @request GET:/api/v1/storage/
     * @secure
     */
    listPlacementProcesses: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @min 0
         * @exclusiveMin true
         * @default 25
         */
        size?: number;
        q?: string;
        /** @uniqueItems true */
        customerIds?: string[];
        /** @uniqueItems true */
        usernames?: string[];
        /** @uniqueItems true */
        status?: PlacementProcessStatusDto[];
        /** @uniqueItems true */
        origins?: PlacementProcessOriginDto[];
        /** @uniqueItems true */
        documentExistence?: PlacementProcessDocumentExistenceFilterDto[];
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PlacementProcessListDto, any>({
        path: `/api/v1/storage/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags storage-logistic-controller
     * @name CreatePlacementProcess
     * @summary Creates a new placement process
     * @request POST:/api/v1/storage/
     * @secure
     */
    createPlacementProcess: (data: PlacementProcessDto, params: RequestParams = {}) =>
      this.request<ResourceCreatedDto, any>({
        path: `/api/v1/storage/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags storage-logistic-controller
     * @name BatchCompletePlacementProcess
     * @summary Complete a batch placement process
     * @request POST:/api/v1/storage/batch/complete
     * @secure
     */
    batchCompletePlacementProcess: (data: PlacementProcessBatchCompleteDto, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/storage/batch/complete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags storage-logistic-controller
     * @name ValidatePlacementProcess
     * @summary Validates Placement Process
     * @request POST:/api/v1/storage/validation
     * @secure
     */
    validatePlacementProcess: (data: PlacementProcessDto, params: RequestParams = {}) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/storage/validation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags storage-logistic-controller
     * @name GetPlacementProcess
     * @summary Get placement process detail data
     * @request GET:/api/v1/storage/{id}
     * @secure
     */
    getPlacementProcess: (id: string, params: RequestParams = {}) =>
      this.request<PlacementProcessDetailDto, any>({
        path: `/api/v1/storage/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags storage-logistic-controller
     * @name GetCabinets
     * @summary Get cabinets for a placement process
     * @request GET:/api/v1/storage/{id}/cabinets
     * @secure
     */
    getCabinets: (id: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/api/v1/storage/${id}/cabinets`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags storage-logistic-controller
     * @name IsCompletable
     * @summary Check if placement process is is completable
     * @request GET:/api/v1/storage/{id}/completable
     * @secure
     */
    isCompletable: (id: string, params: RequestParams = {}) =>
      this.request<PlacementProcessCompletableDto, any>({
        path: `/api/v1/storage/${id}/completable`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags storage-logistic-controller
     * @name CompletePlacementProcess
     * @summary Complete a placement process
     * @request POST:/api/v1/storage/{id}/complete
     * @secure
     */
    completePlacementProcess: (id: string, data: PlacementProcessCompleteDto, params: RequestParams = {}) =>
      this.request<PlacementProcessDetailDto, any>({
        path: `/api/v1/storage/${id}/complete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags storage-logistic-controller
     * @name RevokeDocument
     * @summary removes document from placement process
     * @request DELETE:/api/v1/storage/{id}/document/{documentId}
     * @secure
     */
    revokeDocument: (id: string, documentId: string, params: RequestParams = {}) =>
      this.request<PlacementProcessDto, any>({
        path: `/api/v1/storage/${id}/document/${documentId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags warehouse-controller
     * @name ListWarehouses
     * @summary Returns a list of warehouses
     * @request GET:/api/v1/warehouse/
     * @secure
     */
    listWarehouses: (params: RequestParams = {}) =>
      this.request<WarehouseListDto, any>({
        path: `/api/v1/warehouse/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags warehouse-controller
     * @name CreateWarehouse
     * @summary Creates a new warehouse
     * @request POST:/api/v1/warehouse/
     * @secure
     */
    createWarehouse: (data: WarehouseDataDto, params: RequestParams = {}) =>
      this.request<ResourceCreatedDto, any>({
        path: `/api/v1/warehouse/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags warehouse-controller
     * @name ValidateWarehouse
     * @summary Validates warehouse
     * @request POST:/api/v1/warehouse/validation
     * @secure
     */
    validateWarehouse: (
      data: WarehouseDataDto,
      query?: {
        validateWarehouseNumber?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/warehouse/validation`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags warehouse-controller
     * @name GetWarehouse
     * @summary Get single warehouse
     * @request GET:/api/v1/warehouse/{id}
     * @secure
     */
    getWarehouse: (id: string, params: RequestParams = {}) =>
      this.request<WarehouseDetailDto, any>({
        path: `/api/v1/warehouse/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags warehouse-controller
     * @name UpdateWarehouse
     * @summary Update single warehouse
     * @request PUT:/api/v1/warehouse/{id}
     * @secure
     */
    updateWarehouse: (id: string, data: WarehouseDetailDto, params: RequestParams = {}) =>
      this.request<WarehouseDetailDto, any>({
        path: `/api/v1/warehouse/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
